import * as React from 'react'
import classNames from 'classnames'
import { MenuItemHeader } from 'sdk/menu-items/menu-item-header/MenuItemHeader'

import classes from './style.module.scss'

interface DropdownLink {
  title: string
  path: string
}

interface ComponentProps {
  title: string
  links: DropdownLink[]
  onOpenChange?: (isOpen: boolean) => void
}

export const HeaderItemDropdown: React.FC<ComponentProps> = ({ title, links, onOpenChange }) => {
  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <div className={classes.container} onMouseEnter={() => {
      setIsHovered(true)
      onOpenChange?.(true)
    }} onMouseLeave={() => {
      setIsHovered(false)
      onOpenChange?.(false)
    }}>
      <div className={classes.trigger}>
        <span className={classes.triggerText}>{title}</span>
      </div>

      <div className={classNames(classes.dropdown, {
        [classes.dropdownOpen]: isHovered
      })}>
        {links.map(({ title, path }, index) => (
          <MenuItemHeader key={index} link={path}>
            {title}
          </MenuItemHeader>
        ))}
      </div>
    </div>
  )
}
